import React from 'react';
import { Alert } from '@realm-kf/halcyon-components-react';
import styles from './categoryStepAlert.css';
var CategoryStepAlert = function (_a) {
    var content = _a.content;
    return (React.createElement(Alert, { title: null, variant: "warning", content: content, classes: styles.CategoryStepAlert }));
};
export { CategoryStepAlert };
